import React, { Fragment, memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { Button } from 'src/components/shared/Button'
import { CommonModal } from 'src/components/shared/CommonModal'

interface Props {
  isOpen: boolean
  isRevoking: boolean
  onConfirm(): void
  onClose(): void
}

const RevokeOAuthTokensModalComponent = ({ isOpen, isRevoking, onConfirm, onClose }: Props) => {
  return (
    <CommonModal
      isOpen={isOpen}
      title="Revoke all API tokens?"
      onClose={onClose}
      buttons={
        <Fragment>
          <Button size="small" color="grey" disabled={isRevoking} onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="small"
            color="red"
            loading={isRevoking}
            disabled={isRevoking}
            onClick={onConfirm}
            data-testid="oauth-revoke-tokens-confirm-button"
          >
            Revoke all tokens
          </Button>
        </Fragment>
      }
    >
      <div css={tw`flex flex-col gap-2`}>
        <Typography variant="body2">
          Every access token this customer currently holds stops working immediately. Their
          integration will have to authenticate again with its client ID and secret before it can
          make another call.
        </Typography>
        {/* Says what revocation does *not* do, so it is not mistaken for an off switch. Worded
            status-neutrally on purpose: the Revoke button is enabled for a disabled client too,
            and revocation leaves `deactivatedAt` untouched, so this must not claim the client
            "stays active" — for a disabled client that would be false. */}
        <Typography variant="body2" css={tw`text-shades-500`}>
          This does not change API access or the granted scopes — revoking is not a way to turn
          access off. While API access is enabled, the integration can request a new token
          immediately. Use Disable to turn access off.
        </Typography>
      </div>
    </CommonModal>
  )
}

export const RevokeOAuthTokensModal = memo(RevokeOAuthTokensModalComponent)
